module.exports = __webpack_public_path__ + "static/item_sort_order_calendars-960b1af7d9a45bb33239dd0c2af65e3e.png";